/* ==========================================================================
   Longevity Pet — Landing sotto il Quiz
   Comportamenti: scroll al quiz, tracking GA4, accordion FAQ, CTA sticky.
   Riferimento: _quiz-docs/landing-quiz-specifica.md (§ 11, § 12, § 9, § 13)

   Isolato: tutto sotto il prefisso lpql. Non tocca il motore del quiz.
   Il file può essere incluso da più sezioni: l'inizializzazione è idempotente
   (ogni elemento viene legato una volta sola, vedi marcatore data-lpql-bound).
   ========================================================================== */

(function () {
  'use strict';

  /* ------------------------------------------------------------------
     1. Tracking GA4
     gtag è già definito sulla pagina (Measurement ID G-JKYL2XC6EG).
     Non c'è Google Tag Manager: niente dataLayer.push.
     Se il visitatore rifiuta i cookie analitici (Iubenda consent mode)
     l'evento semplicemente non parte: è il comportamento corretto.
     ------------------------------------------------------------------ */

  function lpqlTrack(name, params) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params || {});
    }
  }

  /* ------------------------------------------------------------------
     2. Scroll al quiz
     Bersaglio: .lp-quiz-section (classe stabile). L'id della sezione è
     dinamico e quindi inutilizzabile come ancora.
     ------------------------------------------------------------------ */

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function lpqlScrollToQuiz() {
    var el = document.querySelector('.lp-quiz-section');
    if (!el) return;
    el.scrollIntoView({
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      block: 'start'
    });
  }

  /* ------------------------------------------------------------------
     3. CTA della landing
     Ogni bottone porta data-lpql-cta con la posizione da tracciare.
     ------------------------------------------------------------------ */

  function initCta(root) {
    var bottoni = root.querySelectorAll('[data-lpql-cta]:not([data-lpql-bound])');

    Array.prototype.forEach.call(bottoni, function (btn) {
      btn.setAttribute('data-lpql-bound', '1');
      btn.addEventListener('click', function () {
        lpqlTrack('quiz_landing_cta', {
          posizione: btn.getAttribute('data-lpql-cta') || ''
        });
        lpqlScrollToQuiz();
      });
    });
  }

  /* ------------------------------------------------------------------
     4. Accordion FAQ
     Un solo pannello aperto per volta. Il primo è già aperto lato Liquid.
     Accessibilità: <button> reale, aria-expanded, aria-controls,
     pannello con role="region" e aria-labelledby, navigabile da tastiera
     (il <button> nativo gestisce Invio e Spazio senza codice aggiuntivo).
     ------------------------------------------------------------------ */

  function chiudiPannello(btn) {
    var pannello = document.getElementById(btn.getAttribute('aria-controls'));
    btn.setAttribute('aria-expanded', 'false');
    if (pannello) pannello.hidden = true;
  }

  function apriPannello(btn) {
    var pannello = document.getElementById(btn.getAttribute('aria-controls'));
    btn.setAttribute('aria-expanded', 'true');
    if (pannello) pannello.hidden = false;
  }

  function initFaq(root) {
    var liste = root.querySelectorAll('.lpql-faq__list:not([data-lpql-bound])');

    Array.prototype.forEach.call(liste, function (lista) {
      lista.setAttribute('data-lpql-bound', '1');
      var domande = lista.querySelectorAll('.lpql-faq__q');

      Array.prototype.forEach.call(domande, function (btn) {
        btn.addEventListener('click', function () {
          var eraAperto = btn.getAttribute('aria-expanded') === 'true';

          // Un solo pannello aperto per volta: chiudo tutti gli altri.
          Array.prototype.forEach.call(domande, function (altro) {
            if (altro !== btn) chiudiPannello(altro);
          });

          if (eraAperto) {
            chiudiPannello(btn);
          } else {
            apriPannello(btn);
            lpqlTrack('quiz_landing_faq_open', {
              domanda: (btn.getAttribute('data-lpql-domanda') || '').trim()
            });
          }
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     5. CTA sticky
     Compare solo quando .lp-quiz-section è uscita dal viewport: finché il
     quiz è a schermo la CTA è già sotto gli occhi dell'utente.
     Se il quiz non è in pagina la barra resta nascosta (non avrebbe dove
     portare).
     ------------------------------------------------------------------ */

  function riservaSpazioSticky(barra) {
    var inner = barra.querySelector('.lpql-sticky__inner');
    var h = inner ? inner.offsetHeight : barra.offsetHeight;
    // Spazio riservato sempre, anche a barra nascosta: evita che l'ultima
    // sezione salti quando la barra compare.
    document.documentElement.style.setProperty('--lpql-sticky-h', h + 'px');
  }

  function initSticky(root) {
    var barre = root.querySelectorAll('.lpql-sticky:not([data-lpql-bound])');

    Array.prototype.forEach.call(barre, function (barra) {
      barra.setAttribute('data-lpql-bound', '1');

      var quiz = document.querySelector('.lp-quiz-section');
      if (!quiz) return;

      riservaSpazioSticky(barra);
      window.addEventListener('resize', function () {
        riservaSpazioSticky(barra);
      });

      if (!('IntersectionObserver' in window)) {
        // Browser senza IntersectionObserver: mostro la barra e basta.
        barra.classList.add('is-visible');
        return;
      }

      var osservatore = new IntersectionObserver(
        function (voci) {
          voci.forEach(function (voce) {
            barra.classList.toggle('is-visible', !voce.isIntersecting);
          });
        },
        { threshold: 0 }
      );

      osservatore.observe(quiz);
    });
  }

  /* ------------------------------------------------------------------
     6. Profondità di scroll — 50% e 90%, una volta sola per sessione
     di pagina (flag, così l'evento non parte a ripetizione).
     ------------------------------------------------------------------ */

  var soglieSparate = {};

  function controllaScroll() {
    var doc = document.documentElement;
    var altezzaTotale = Math.max(
      doc.scrollHeight,
      document.body ? document.body.scrollHeight : 0
    );
    if (altezzaTotale <= 0) return;

    var letto = (window.pageYOffset || doc.scrollTop) + window.innerHeight;
    var percentuale = (letto / altezzaTotale) * 100;

    [50, 90].forEach(function (soglia) {
      if (percentuale >= soglia && !soglieSparate[soglia]) {
        soglieSparate[soglia] = true;
        lpqlTrack('quiz_landing_scroll', { soglia: String(soglia) });
      }
    });
  }

  function initScrollDepth() {
    if (window.__lpqlScrollBound) return;
    window.__lpqlScrollBound = true;

    var inAttesa = false;
    window.addEventListener(
      'scroll',
      function () {
        if (inAttesa) return;
        inAttesa = true;
        window.requestAnimationFrame(function () {
          inAttesa = false;
          controllaScroll();
        });
      },
      { passive: true }
    );

    controllaScroll();
  }

  /* ------------------------------------------------------------------
     7. Dati strutturati FAQ: una sola FAQPage per pagina
     Rete di sicurezza se qualcuno duplica la sezione FAQ lasciando la
     spunta attiva su entrambe: tengo la prima, rimuovo le altre.
     ------------------------------------------------------------------ */

  function initJsonLdUnico() {
    var blocchi = document.querySelectorAll('script[data-lpql-faq-jsonld]');
    for (var i = 1; i < blocchi.length; i++) {
      if (blocchi[i].parentNode) blocchi[i].parentNode.removeChild(blocchi[i]);
    }
  }

  /* ------------------------------------------------------------------
     8. Avvio
     ------------------------------------------------------------------ */

  function init(root) {
    var base = root || document;
    initCta(base);
    initFaq(base);
    initSticky(base);
    initScrollDepth();
    initJsonLdUnico();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Editor del tema: quando una sezione viene ricaricata, rilego i suoi nodi.
  document.addEventListener('shopify:section:load', function (evento) {
    init(evento.target || document);
  });

  // Esposte per eventuale uso da altre sezioni della landing.
  window.lpqlScrollToQuiz = lpqlScrollToQuiz;
  window.lpqlTrack = lpqlTrack;
})();
